export * from './waitingForCall';
export * from './validation';
export * from './exitModule';
export * from './needHelp';

export const modals = {
	waitingForCall: 'waitingForCall',
	validation: 'validation',
	exitModule: 'exitModule',
	needHelp: 'needHelp',
};
